var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from 'axios';
import { fetchWrapper } from '../utilities/fetchWrapper';
const BASE_URL = 'https://uploads.design.vpsvc.com/api/v1/uploads';
/**
 * Gets metadata for all assets under a given owner ID and tenant.
 * @param {GetUploadsParams} ParametersObject Object used to pass parameters into this function. See type documentation for more detailed information.
 * @returns {UploadsMetadataCollection} The metadata of the retieved uploads.
 */
export function getUploads({ headers, owner, tenant, includeHidden, signal, limit, offset, includeSubTenants, scopeToUserFolders, folderName, depth, }) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {};
        if (owner) {
            params.owner = owner;
        }
        if (includeHidden) {
            params.includeHidden = `${includeHidden}`;
        }
        params.tenant = tenant;
        if (limit) {
            params.limit = `${limit}`;
        }
        if (offset) {
            params.offset = offset;
        }
        if (includeSubTenants) {
            params.includeSubTenants = `${includeSubTenants}`;
        }
        if (scopeToUserFolders) {
            params.scopeToUserFolders = `${scopeToUserFolders}`;
        }
        if (folderName) {
            params.folderName = `${folderName}`;
        }
        if (depth) {
            params.depth = `${depth}`;
        }
        const uploadsResponse = yield fetchWrapper(`https://uploads.design.vpsvc.com/api/v2/assets`, {
            method: 'GET',
            headers: Object.assign(Object.assign({}, headers), { 'Cache-Control': 'no-cache' }),
            query: params,
            signal,
        }).catch((error) => {
            throw error;
        });
        return uploadsResponse;
    });
}
/**
 * Gets a post URL for the given owner and parameters. Defaults to the token's owner ID if none is passed in.
 * @param {GetPostUrlParams} ParametersObject Object used to pass parameters into this function. See type documentation for more detailed information.
 * @returns {string} The URL to Post an upload for the provided owner.
 */
export function getPostUrl({ headers, process, url, owner, signal }) {
    return __awaiter(this, void 0, void 0, function* () {
        const params = {};
        if (process) {
            params.process = process;
        }
        if (url) {
            params.url = url;
        }
        if (owner) {
            params.owner = owner;
        }
        const response = yield fetchWrapper(`${BASE_URL}/postUrl`, {
            method: 'GET',
            headers,
            query: params,
            signal,
        }).catch((error) => {
            throw new Error(`Failed to get upload post url: ${error.message}`);
        });
        return response.postUrl;
    });
}
/**
 * Deletes the upload specified by the given uploadId.
 * @param {DeleteUploadParams} ParametersObject Object used to pass parameters into this function. See type documentation for more detailed information.
 */
export function deleteUpload({ headers, uploadId, ownerId, signal }) {
    return __awaiter(this, void 0, void 0, function* () {
        const path = ownerId ? `${BASE_URL}/${uploadId}?owner=${ownerId}` : `${BASE_URL}/${uploadId}`;
        yield fetchWrapper(path, {
            method: 'DELETE',
            headers,
            signal,
        }).catch((error) => {
            throw new Error(`Failed to delete upload: ${error.message}`);
        });
    });
}
/**
 * Hide and Unhide the upload specified by the given uploadId.
 * @param {UploadMetaDataParams} ParametersObject Object used to pass parameters into this function. See type documentation for more detailed information.
 */
export function hideUnhide({ uploadId, hide, headers, signal, ownerId }) {
    return __awaiter(this, void 0, void 0, function* () {
        const path = ownerId ? `${BASE_URL}/${uploadId}?owner=${ownerId}` : `${BASE_URL}/${uploadId}/metadata`;
        yield axios(path, {
            method: 'PUT',
            headers,
            signal,
            data: {
                userData_hidden: hide,
            },
        }).catch((error) => {
            throw new Error(`Failed to perform hide/unhide: ${error.message}`);
        });
    });
}
//# sourceMappingURL=UploadsMetadataService.js.map